<!--
// Don't render if there's no media.
// The "About" text will be visible in str-about-description if this doesn't render.
-->
<if(state.mediaList.length)>
    <section class="str-about-video app-layout--negate-gutters" key="str-about-video">
        <subscribe to=window on-resize("handleResize")/>
        <if(state.isSmall)>
            <style>
                .mweb .str-about-video__text,
                .mweb .str-about-video__media--landscape,
                .mweb .str-about-video__media--portrait {
                    height: ${state.mobileCarouselHeight + 'px'};
                }
            </style>
        </if>
        <div class='str-about-video__banner'>
            <ebay-carousel
                class=`str-about-video__items-per-slide-${state.itemsPerSlide}`
                items-per-slide=state.itemsPerSlide
                thumbnail="true"
                gap="4"
                no-peek="true">
                <if(state.description && state.itemsPerSlide > 1)>
                    <@item>
                        <div class="str-about-video__text">
                            <str-about-description ...state.description />
                        </div>
                        <style>
                            /* If description renders here in carousel,
                            hide the str-about-description component. */
                            .str-about-description {
                                padding-top: 28px;
                            }
                            .str-about-description__about-intro {
                                display: none;
                            }
                            .str-about-description__description {
                                margin-bottom: 0;
                            }
                        </style>
                    </@item>
                </if>
                <for|media, index| of=state.mediaList>
                    <@item key=`media-${index}`>
                        <about-media media=media reportTracking=component.reportTracking />
                    </@item>
                </for>
            </ebay-carousel>
        </div>
    </section>
</if>

<macro|{ media, reportTracking }| name="about-media">
    <div class=media.class>
        <ebay-video
            on-play('sendTracking', media.tracking)
            on-report('navigateToReport', reportTracking)
            thumbnail=media.thumbnail
            a11y-play-text=media.text.a11y.play
            a11y-load-text=media.text.a11y.loading
            a11y-report-text=media.text.a11y.report
            error-text=media.text.error
            report-text=media.text.report
            play-view="inline"
            volume="0.25">
            <for|src| of=media.sources>
                <@source src=src.url type=src.type/>
            </for>
        </ebay-video>
    </div>
</macro>
